export default {
    PtWorkspaceFolderTree: {
        noData: 'No folders found',
        myWorkspace: 'My workspaces',
        sharedWorkspace: 'Shared workspaces',
        publicWorkspace: 'Company workspaces',
        noFolder: 'No folder in this workspace, please choose another workspace.',
    },
};
